// ui/components/shared/UseCaseSelectorCard.tsx
import { Box, Typography } from "@mui/material";

interface UseCaseSelectorCardProps {
  title: string;
  imageSrc: string;
  options: string[];
  id?: string;
}

const UseCaseSelectorCard = ({ title, imageSrc, options, id }: UseCaseSelectorCardProps) => {
  return (
    <Box
      id={id}
      sx={{
        border: '5px solid #A0B29F',
        borderRadius: '15px',
        padding: '1rem',
        backgroundColor: '#F8F9F8',
        width: '300px',
        textAlign: 'center',
      }}
    >
      <img src={imageSrc} alt={title} style={{ width: '100%', borderRadius: '10px' }} />
      <Typography fontWeight="bold" fontSize="1.1rem" mt={1}>
        {title} 
      </Typography>
      <select style={{ width: '100%', marginTop: '0.5rem', padding: '0.5rem', fontSize: '1rem' }}>
        {options.map((option, idx) => (
          <option key={idx} value={option.toLowerCase()} style={{ color: idx === 0 ? "black" : "gray" }}>
            {option}
          </option>
        ))}
      </select>
    </Box>
  );
};

export default UseCaseSelectorCard;